import React from 'react';
import { CollageContainer, CollageItem, StyledImage } from './styled';
import { Photo } from '../../../graphql/graphql';

interface GalleryCollageProps {
  photos: Photo[];
  galleryDescription: string;
  onOpenGallery: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    photoNumber?: number
  ) => void;
}

export const GalleryCollage: React.FC<GalleryCollageProps> = ({
  photos,
  galleryDescription,
  onOpenGallery
}) => {
  const collagePhotos = photos.slice(0, 3);

  if (collagePhotos.length < 3) {
    return null;
  }

  return (
    <CollageContainer data-cy="residence-gallery-collage">
      {collagePhotos.map((photo, index) => (
        <CollageItem
          key={index}
          $position={index}
          onClick={e => onOpenGallery(e, index + 1)}
        >
          <StyledImage
            src={photo.full}
            alt={`${galleryDescription}-collage-photo-${index + 0}`}
            fill
            priority={index === 0}
            data-cy="residence-gallery-collage-image"
          />
        </CollageItem>
      ))}
    </CollageContainer>
  );
};
